import {ThunkAction} from "redux-thunk";
import {RootState} from "../../reducers";
import {Action} from "redux";
import {HTTP} from "../../helpers/axios";
import {serverRoutes} from "../../api/serverRoutes";

export const lockdebtAction = (data:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    try {
        const response=  await   HTTP(getState,dispatch).post(serverRoutes.lockDebt,data);

        dispatch({
            type: 'ALL_DEBTS',
            payload: response.data
        });

        let error=false;
        callback(error);
    }catch (e) {
        let error=true;
        callback(error);
    }


};
